import { FeatureImpl } from './Feature';
import { LineString, Point } from 'ol/geom';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import { Utils } from './Utils';
import { Icon, Style } from 'ol/style';
import { Feature as OLFeature } from 'ol';
export class AircraftImpl extends FeatureImpl {
    constructor(data, config, departure, arrival) {
        super(data, config);
        this.departure = departure;
        this.arrival = arrival;
        this._style = new Style({
            image: new Icon({
                src: require('../icons/aircraft.svg')
            })
        });
        this._activeStyle = new Style({
            image: new Icon({
                src: require('../icons/activeAircraft.svg')
            })
        });
    }
    setRotation(rotation) {
        this._activeStyle.getImage().setRotation(rotation);
        this._style.getImage().setRotation(rotation);
    }
    create() {
        this._style = new Style({
            image: new Icon({
                src: this._config.aircraft
            })
        });
        this._activeStyle = new Style({
            image: new Icon({
                src: this._config.aircraftActive
            })
        });
        const flight = this.data;
        const departureCoordinates = [
            flight.departure.airport.latitude,
            flight.departure.airport.longitude
        ];
        const arrivalCoordinates = [flight.arrival.airport.latitude, flight.arrival.airport.longitude];
        const percent = flight.pathCompletion;
        const line = new LineString(Utils.getCirclePoints(departureCoordinates, arrivalCoordinates));
        line.transform('EPSG:4326', 'EPSG:3857');
        this.feature = new OLFeature({
            geometry: new Point(line.getCoordinates()[percent - 1])
        });
        this.feature.setStyle(this.style);
        const coords = Utils.getCirclePoints(departureCoordinates, arrivalCoordinates);
        const from = coords[percent - 1];
        const to = coords[percent];
        this.setRotation(Utils.getAngleOfRotationMercator(from[0], from[1], to[0], to[1]));
        const vectorSource = new VectorSource({
            features: [this.feature]
        });
        this._layer = new VectorLayer({
            zIndex: 10,
            source: vectorSource
        });
        return this._layer;
    }
    isEqual(aircraft) {
        return this.data.uniqueId === aircraft.data.uniqueId;
    }
}
